import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import AttachmentList from '../../../form-widgets/WidgetLongMessage/Components/AttachmentList';
import { useAlertAttachments } from '../../../hooks';
import { CollapsableSection } from './CollapsableSection';
export const AlertAttachments = ({ data }) => {
    var _a;
    const { t } = useAlertUiTranslation();
    const { handleGetAttachment } = useAlertAttachments();
    if (!((_a = data.emailAttachments) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (React.createElement(CollapsableSection, { title: t('common.attachment'), header: null },
        React.createElement(AttachmentList, { emailAttachments: data.emailAttachments, onGetAttachment: handleGetAttachment })));
};
